// constants

export const AUTH_TOKEN = "tfToken";
export const AUTH_REFRESH_TOKEN = "tfRefreshToken";
export const PLAID_LINK_TOKEN = "tfPlaidLinkToken";
